import { useReactFlow } from "reactflow";
import commonComponents from "layouts/Flow Designer/schemas/commonComponents";
import { v4 as uuidv4 } from "uuid";

const parseLabel = (label) => {
  return label?.toLowerCase()?.replace(/-| /g, "_");
};

const generateKey = (key, index) => {
  return key + "_" + index;
};

const useComponentIdGenerator = () => {
  const { getNodes } = useReactFlow();

  const generateComponentId = (step, additionalNodes) => {
    const foundComponent = commonComponents.find((component) => component.type === step.type);
    const newKey = foundComponent
      ? parseLabel(foundComponent.label)
      : parseLabel(step?.componentFiles?.schema?.componentId);
    const nodes = additionalNodes ? [...getNodes(), ...additionalNodes] : getNodes();
    const nodesByType = foundComponent
      ? nodes.filter((node) => node.data?.type === step.type)
      : nodes.filter(
          (node) =>
            node.data?.componentFiles?.schema?.componentId ===
            step.componentFiles?.schema?.componentId
        );
    const getNodeByIndex = (index) =>
      nodesByType.find((node) => node.data?.componentKey === generateKey(newKey, index));

    let newIndex = 1;

    for (let i = 1; i <= nodesByType.length; i++) {
      const node = getNodeByIndex(i);
      if (node) {
        newIndex++;
        continue;
      }

      newIndex = i;
      break;
    }

    return generateKey(newKey, newIndex);
  };

  const generateNodeId = () => {
    return `dndnode_${uuidv4()}`;
  };

  return { generateComponentId, generateNodeId };
};

export default useComponentIdGenerator;
